import { Button, Flex, Result } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router-dom';

const NotFound = () => {
    const navigate = useNavigate();
    const handleRedirect = () => {
        navigate('/');
    };
    return (
        <div>
            <Result
                status="404"
                title="404"
                subTitle="The page you visit does not exist"
                extra={
                    <Button type="primary" onClick={handleRedirect}>
                        Back to Home Page
                    </Button>
                }
            />
        </div>
    );
};

export default NotFound;
